import {ErrorAPI} from "../api/ErrorAPI";

export class ErrorService {

    private static instance: ErrorService;
    private errorAPI: ErrorAPI

    private constructor() {
        this.errorAPI = new ErrorAPI();
    }

    async sendErrorLog(error: Error, url: string, verificationId: string) {
        await this.errorAPI.sendErrorLog(error, url, verificationId);
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new ErrorService();
        }
        return this.instance;
    }
}